import React, { useEffect, useState } from 'react';
import { generateQRCode } from '../task-barcode-printer/task-barcode-printer';
import { Box } from '@mui/material';


interface QRCodeBoxProps {
    value: string;
    size?: string | number;
    centered?: boolean
    showValue?: boolean
}

function QRCodeBox({ value, size, centered, showValue }: QRCodeBoxProps) {
    const [qrCode, setQRCode] = useState("")
    useEffect(() => {
        generateQRCode(value).then((v) => setQRCode(v))
    }, [value])
    const styles = centered ? { width: "100%", textAlign: "center" } : {}
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignContent: "center",
            justifyContent: "center",
            alignItems: "center",
            gap: "0",
        }}>
            <div>
                <Box
                    component={"img"}
                    width={size ?? 200}
                    height={size ?? 200}
                    src={qrCode}
                    sx={{ mb: 0, margin: 0, padding: 0 }}
                />
            </div>

            {showValue && <div><b>{value}</b></div>}
        </div>
    );
}

export default QRCodeBox;